module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-顶部图.e66d381c.png";